import { jsPDF } from "jspdf";
import { drawPosterCanvas } from "../../../utils/posterCanvas.js";

function safeFilename(title, maxLen) {
  return (title || "recette")
    .replace(/[^a-zA-Z0-9\u00C0-\u024F\s-]/g, "")
    .replace(/\s+/g, "-")
    .slice(0, maxLen);
}

export function createDownloadPdf(
  selectedRecipe,
  selectedTemplate,
  user,
  preloadedImageUrl,
  logoDataUrl,
  setDownloading,
  setError,
) {
  return async () => {
    if (!selectedRecipe) return;
    setDownloading(true);
    setError(null);
    try {
      const canvas = await drawPosterCanvas({
        recipe: selectedRecipe,
        templateId: selectedTemplate,
        userName: user?.first_name || user?.username,
        imageDataUrl: preloadedImageUrl,
        logoDataUrl,
      });
      if (!canvas) throw new Error("Génération échouée");
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });
      const pdfW = pdf.internal.pageSize.getWidth();
      const pdfH = pdf.internal.pageSize.getHeight();
      const ratio = Math.min(pdfW / canvas.width, pdfH / canvas.height);
      const w = canvas.width * ratio;
      const h = canvas.height * ratio;
      pdf.addImage(imgData, "PNG", (pdfW - w) / 2, (pdfH - h) / 2, w, h);
      pdf.save(`JesCook-${safeFilename(selectedRecipe.title, 40)}.pdf`);
    } catch (err) {
      setError(err.message || "Erreur export");
    } finally {
      setDownloading(false);
    }
  };
}
